module.exports = __webpack_public_path__ + "thumbnail-eb0d49cc45548e34a754deab4f76a240.png";